import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { FirstOrderBanner } from '../FirstOrderBanner';
import { BackToTop } from '../BackToTop';
import { SeasonalOverlay } from '../../seasonal/SeasonalOverlay';

export const Layout = ({ children }) => {
  const [searchParams] = useSearchParams();

  // Persist ?ref= code across navigation so it survives page changes
  useEffect(() => {
    const ref = searchParams.get('ref');
    if (ref) {
      sessionStorage.setItem('referral_code', ref.trim().toLowerCase());
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen flex flex-col bg-shrimp-bg">
      <Header />
      <main className="flex-1" data-testid="main-content">
        {children}
      </main>
      <Footer />
      <FirstOrderBanner />
      <BackToTop />
      <SeasonalOverlay />
    </div>
  );
};
